import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerWorkspacePage from "@/pages/partner/PartnerWorkspacePage";
export const Route = createFileRoute("/partner/documents")({
  head: () =>
    pageHead(
      "Partner Documents",
      "Your authorized Partner company workspace.",
      "/partner/documents",
      true,
    ),
  component: () => <PartnerWorkspacePage section="documents" />,
});
